import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { CreateEntityButtonConfig } from 'record-it-components/pageContentLayout/ManageEntitiesContentLayout/ManageEntitiesContentLayout';
export function useEmptyCreateEntityButtonConfig(t0) {
  const $ = _c(5);
  const {
    onCreateEntity,
    text,
    visible
  } = t0;
  const t1 = visible !== false;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== onCreateEntity || $[2] !== t1 || $[3] !== text) {
    t3 = {
      text,
      onCreateEntity,
      visible: t1,
      dropdownItems: t2,
      getDropdownItemDisplayText: _temp,
      getDropdownItemKey: _temp2
    };
    $[1] = onCreateEntity;
    $[2] = t1;
    $[3] = text;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp2() {
  return "";
}
function _temp() {
  return "";
}
export type UseEmptyCreateEntityButtonConfigOptions = {
  text: string;
  /** default: true */
  visible?: boolean;
  onCreateEntity: () => void;
};